import type { Location } from '../../types';

export const locations: Location[] = [
  {
    id: 'ballroom',
    name: 'Great Room 1 & 2',
    building: 'W Hotel, South Beach',
    floor: 'Main Floor',
    capacity: 300,
  },
  {
    id: 'grove',
    name: 'Grove Patio',
    building: 'W Hotel, South Beach',
    floor: 'Main Floor',
    capacity: 500,
  },
  {
    id: 'lawn',
    name: 'Lawn',
    building: 'W Hotel, South Beach',
    floor: 'Main Floor',
    capacity: 500,
  },
  {
    id: 'dinner',
    name: 'Casa Tua, Miami Beach',
    building: '1700 James Ave, Miami Beach, FL 33139',
    capacity: 400,
  },
];
